<template>
  <div class="productList">
    <div class="list" v-if="list.length">
      <div class="item flex-ac" v-for="(item, index) in list" :key="item.skuid">
        <div
          :class="[item.ischoose ? 'active' : '', 'chooseBtn']"
          v-if="orgtype != 'juzi'"
          @click="choice(index)"
        ></div>
        <img :src="item.path1" @click.stop="godetail(item.itemid)" />
        <div class="rightBox" @click.stop="godetail(item.itemid)">
          <p class="name">{{ item.name }}</p>
          <div class="flex-js-ac bottomWrap" v-if="orgtype != 'juzi'">
            <p class="oldPrice">¥{{ item.price }}</p>
            <div class="stepBox flex-ac">
              <div
                :class="[item.num <= 1 ? 'can' : '', 'subtract stepBtn']"
                @click.stop="addToCart(0, index, item)"
              ></div>
              <div class="num">{{ item.num }}</div>
              <div
                :class="[item.num < item.canbuycnt ? 'can' : '', 'add stepBtn']"
                @click.stop="addToCart(1, index, item)"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnBox flex-js-ac" v-if="list.length && orgtype != 'juzi'">
      <div class="flex-ac">
        <div
          :class="[allChoiceFlag ? 'active' : '', 'chooseBtn']"
          @click="Allchoice()"
        ></div>
        <!-- <van-checkbox v-model="allChoiceFlag" checked-color="#FC0324" @click="Allchoice()"></van-checkbox> -->
        <span class="ml10">全选</span>
      </div>
      <div class="flex-ac">
        <div class="commonBtn addBtn" @click="addAll">加入购物车</div>
        <div class="commonBtn buyBtn" @click="submit">立即购买</div>
      </div>
    </div>
    <div class="noData" v-if="!list.length && loaded == true">
      <img src="../../assets/images/emptyorder.png" />
      <p class="">暂无精选商品~</p>
    </div>
    <div class="homeBtn" v-if="orgtype != 'juzi'" @click="homeClick">
      <img src="/static/images/homebtn.png" />
    </div>
  </div>
</template>

<script>
import {
  isWx,
  basepath,
  exclusiveidFn,
  pointParams,
  parametersCombine,
  isWeixin,
  fenxiang,
  isApp
} from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'
import { Tag } from 'vant'

export default {
  name: 'productList',
  data() {
    return {
      list: [], // 推荐商品列表
      totalNumber: 0,
      allChoiceFlag: true, // 全选
      loaded: false,
      orgtype: this.$route.query.orgtype
    }
  },
  components: {
    [Tag.name]: Tag
  },
  created() {
    console.log(window.location.href)
    console.log(this.$route.query.orgtype)
    if (this.$route.query.orgtype != 'juzi') {
      if (
        isWx == 3 &&
        this.waptoken.waptoken &&
        this.waptoken.waptoken == this.waptoken.tourists
      ) {
        localStorage.setItem('htmlurl', window.location.href)
        window.location = '/login?routeval=html'
        return
      }
    }

    this.share()
    this.getGoodsList()
  },
  methods: {
    share() {
      if (isWeixin()) {
        var arg = isApp(),
          shareInfo
        shareInfo = {
          title: encodeURIComponent('皮肤测试'),
          desc: encodeURIComponent('AI皮肤测试，充分了解您你的皮肤状况！'),
          type: 'skinAnalysis',
          path: 'skinAnalysis',
          dataStr:
            'type=skinAnalysis&emptybottle=emptybottle&orgtype=' + this.orgtype,
          imgx: this.staticImgUrl + 'Uploads/share/ndo1.png'
        }
        if (arg.indexOf('xcx') >= 0) {
          shareInfo = {
            type: 'skinAnalysis',
            title: encodeURIComponent('皮肤测试'),
            link:
              basepath +
              'skinAnalysis?path=' +
              (this.$route.query.path ? this.$route.query.path : '') +
              arg,
            img: this.staticImgUrl + 'Uploads/share/ndo1.png'
          }
          wx.miniProgram.postMessage({ data: shareInfo })
        } else {
          fenxiang(shareInfo)
        }
      }
    },
    getGoodsList: function() {
      let url
      if (this.$route.query.action == 'goods') {
        url =
          this.$ajax.getRecommend_YiYuanApi_URL +
          '?goodsid=' +
          this.$route.query.goodsid
      } else {
        if (this.$route.query.orgtype == 'juzi') {
          url =
            this.$ajax.getRecommend_YiYuanApickys_URL +
            '?orderid=' +
            sessionStorage.getItem('detail_id')
        } else {
          url =
            this.$ajax.getRecommend_YiYuanApi_URL +
            '?orderid=' +
            sessionStorage.getItem('detail_id')
        }
      }
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          let list = res.data.list
          list.forEach((item) => {
            item.num = 1
            item.ischoose = true
          })
          this.loaded = true
          this.list = list
          this.count()
        }
      })
    },
    // 商品数量加减
    addToCart(type, index, item) {
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt)
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
      } else {
        if (num <= 1) {
          this.$toast('不能再减了')
          return
        }
        num += -1
      }

      this.list[index].num = num
    },
    // 批量加入购物车
    addAll() {
      let skuids = [],
        buynum = [],
        params,
        url = this.$ajax.addShoppingCart_URL
      this.list.forEach((item) => {
        if (item.ischoose) {
          skuids.push(item.skuid)
          buynum.push(item.num)
        }
      })

      if (!skuids.length) {
        this.$toast('请选择要加入购物车的商品')
        return
      }

      params = {
        skuid: skuids.join(),
        itemnum: buynum.join()
      }

      this.$customRequestAjax.post(url, params).then((res) => {
        if (res.data.code == 200) {
          this.$store.commit('ADD_CART_INIT_DATA', 1)
          this.$toast('已成功加入购物车')
        }
      })
    },
    // 选择/取消选择
    choice(index) {
      this.list[index].ischoose = this.list[index].ischoose ? false : true
      this.count()
    },
    // 全选/取消全选
    Allchoice() {
      if (this.allChoiceFlag) {
        this.list.forEach((item) => {
          item.ischoose = false
        })
        this.allChoiceFlag = false
      } else {
        this.list.forEach((item) => {
          item.ischoose = true
        })
        this.allChoiceFlag = true
      }
    },
    // 计算已选中的项数量
    count() {
      let count = 0,
        list = this.list

      list.forEach((item) => {
        if (item.ischoose) {
          count += 1
        }
      })

      this.allChoiceFlag = count === list.length ? true : false
    },
    godetail(itemid) {
      if (this.orgtype == 'juzi') {
        return
      }

      let arg = isApp()
      if (arg == '') {
        window.location = '/productdetail?itemid=' + itemid + '&skinType=1'
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goItemDetail',
            itembaseid: itemid
          })
        )
      } else {
        wx.miniProgram.navigateTo({
          url:
            '/pages/product/main?itemid=' +
            itemid +
            '&skinType=1' +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      }
    },
    // 提交
    submit() {
      let list = this.list,
        url,
        skuids = [],
        buynum = [],
        totalnum = 0,
        totalmoney = 0

      list.forEach((item) => {
        if (item.ischoose) {
          skuids.push(item.skuid)
          buynum.push(item.num)
          totalnum += item.num
          totalmoney += item.num * item.price
        }
      })

      if (!skuids.length) {
        this.$toast('请选择要购买的商品')
        return
      }

      url =
        this.$ajax.checkOrder_URL +
        '?skuids=' +
        skuids.join() +
        '&buynum=' +
        buynum.join()
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          let shopConfirmResult = {
            skuidArr: skuids,
            itemNum: buynum,
            skuidArrOversea: [],
            liveId: [],
            roomId: [],
            from: 2,
            orderfrom: 1,
            itemNumOversea: [],
            LiveIdArrOversea: [],
            roomIdArrOversea: [],
            totalmoney: totalmoney.toFixed(2),
            totalnum: totalnum
          }
          let arg = isApp()
          if (arg == '') {
            if (
              this.waptoken.waptoken &&
              this.waptoken.waptoken == this.waptoken.tourists
            ) {
              localStorage.setItem('htmlurl', window.location.href)
              window.location = '/login?routeval=html'
              return
            }
            localStorage.setItem(
              'shopConfirmResult',
              JSON.stringify(shopConfirmResult)
            )

            let query = parametersCombine()
            this.$router.push({
              path: '/order',
              query: query
            })
          } else if (arg.indexOf('xcx') < 0) {
            let obj = {
              type: 'skinAnalysis',
              skuids: shopConfirmResult.skuidArr.join(),
              item_num: shopConfirmResult.itemNum.join(),
              from: shopConfirmResult.from
            }
            this.$commonburiedPoint({
              data: {
                scenepoint: window.document.title,
                scenedesc: window.location.href,
                url: 'order-confirm'
              },
              rnType: 'skinAnalysis',
              callback: () => {
                window.ReactNativeWebView.postMessage(JSON.stringify(obj))
              }
            })
          } else {
            shopConfirmResult.orderHadOnShow = 0
            shopConfirmResult.isInitData = 1
            shopConfirmResult.live_id = ''
            shopConfirmResult.type = 'skinAnalysis'
            wx.miniProgram.navigateTo({
              url:
                '/pages/order/main?shopConfirmResult=' +
                JSON.stringify(shopConfirmResult) +
                '&scenepoint=' +
                encodeURIComponent(window.document.title)
            })
          }
        } else {
        }
      })
    },
    // 跳转至首页
    homeClick: function() {
      var arg = isApp()
      if (arg == '') {
        window.location.href = '/'
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goIndex'
          })
        )
      } else {
        wx.miniProgram.switchTab({ url: '/pages/index/main' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.homeBtn {
  z-index: 10;
  position: fixed;
  right: 0.17rem;
  bottom: 0.8rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 0.4rem;
    height: 0.4rem;
    display: block;
  }
}
.noData {
  margin: 30% auto 0;
  text-align: center;
  img {
    margin: 0 auto;
    width: 0.88rem;
    height: 0.88rem;
  }
  p {
    margin-top: 0.14rem;
    font-size: 0.14rem;
  }
}
.flex-ac {
  display: flex;
  align-items: center;
}
.header {
  padding: 0.1rem 0.1rem 0 0;
  text-align: right;
  p {
    font-size: 0.14rem;
  }
}
.labelWrap {
  margin: 0 auto;
  padding: 0.08rem 0.1rem;
  background: #fefceb;
  color: #666;
  font-size: 0.14rem;
  .tips {
    width: 80%;
    p {
      width: 100%;
      height: auto;
      word-wrap: break-word;
      word-break: break-all;
      overflow: hidden;
    }
  }
  .buyRule {
    span {
      height: 0.22rem;
    }
    img {
      margin-left: 0.04rem;
      width: 0.06rem;
      height: 0.09rem;
    }
  }
}
.chooseBtn {
  margin-right: 0.1rem;
  width: 0.18rem;
  height: 0.18rem;
  background: url('/static/images/skinAnalysis/default.png') no-repeat;
  background-size: 100%;
  &.active {
    background: url('/static/images/skinAnalysis/selected.png') no-repeat;
    background-size: 100%;
  }
}
.list {
  margin: 0.1rem 0.1rem 0;
  font-size: 0.12rem;
  padding-bottom: 0.7rem;
  .item {
    margin-bottom: 0.1rem;
    padding: 0.16rem 0.1rem;
    background: #fff;
    img {
      margin: 0 0.08rem;
      width: 0.8rem;
      height: 0.8rem;
    }
    .rightBox {
      position: relative;
      flex: 1;
      height: 0.8rem;
      font-size: 0.12rem;
      .name {
        font-size: 0.14rem;
        color: #292929;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        overflow: hidden;
      }
      .bottomWrap {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
      }
      .oldPrice {
        color: #292929;
        font-weight: bold;
      }
      .currentPrice {
        color: #fc0324;
        .price {
          font-size: 0.14rem;
          font-weight: bold;
        }
      }
      .stepBox {
        width: 0.86rem;
        height: 0.22rem;
        border: 1px solid #e5e5e5;
        text-align: center;
        border-radius: 0.14rem;
        .add,
        .subtract {
          width: 0.24rem;
          height: 100%;
        }

        .subtract {
          background: url(../../../static/images/productList/icon-subtract.png)
            no-repeat;
          background-size: 0.09rem;
          background-position: 0.06rem 0.05rem;
          &.can {
            background: url(../../../static/images/productList/icon-subtract-disabled.png)
              no-repeat;
            background-size: 0.09rem;
            background-position: 0.06rem 0.05rem;
          }
        }

        .add {
          background: url(../../../static/images/productList/icon-add.png)
            no-repeat;
          background-size: 0.09rem;
          background-position: 0.06rem 0.05rem;
          &.can {
            background: url(../../../static/images/productList/icon-add.png)
              no-repeat;
            background-size: 0.09rem;
            background-position: 0.06rem 0.05rem;
          }
        }
        .num {
          width: 0.36rem;
          height: 0.22rem;
          line-height: 0.22rem;
          background: #e5e5e5;
          color: #333;
        }
      }
    }
  }
}
.btnBox {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #fff;
  font-size: 0.16rem;
  padding: 0 0.1rem 0 0.2rem;
  .commonBtn {
    width: 1.1rem;
    height: 0.38rem;
    line-height: 0.38rem;
    border-radius: 0.2rem;
    color: #fff;
    text-align: center;
    margin: 0 0.05rem;
    &.buyBtn {
      background: linear-gradient(to right, #fc0324, #ff144f);
    }
    &.addBtn {
      background: linear-gradient(to right, #ffa700 0%, #ffba00 100%);
    }
  }
  .ml10 {
    margin-left: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/skinAnalysis/skinProducts.vue